import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChangeEvent, VirtualScrollComponent } from 'angular2-virtual-scroll';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

import { NarwhalQueryParameters } from '../../api/narwhal.query';
import { NarwhalListResultDto, MaxNarwhalProperties, NarwhalDto } from '../../api/narwhalListResultDto';
import { NarwhalService } from '../../narwhal.service';
import { AuthService } from '../../shared/auth/auth.service';
import { defs } from '../../defs';
import { NGXLogger } from 'ngx-logger';

@Component({
	selector: 'narwhalia-my-swarm-list',
	templateUrl: './my-swarm-list.component.html',
	styleUrls: ['./my-swarm-list.component.scss']
})
export class MySwarmListComponent extends OnDestroyMixin implements OnInit {
	@ViewChild(VirtualScrollComponent) private virtualScroll: VirtualScrollComponent;
	buffer: any = [];
	readonly bufferSize: number = 30;
	loading: boolean;
	scrollItems: NarwhalDto[];
	totalCount: number;
	maxProps: MaxNarwhalProperties;
	endOfList$: Subject<ChangeEvent>;

	constructor(
		private route: ActivatedRoute,
		private narwhalService: NarwhalService,
		private authService: AuthService,
		private log: NGXLogger) {
		super();
		this.endOfList$ = new Subject();
	}

	ngOnInit() {
		this.route.queryParams.subscribe((params: NarwhalQueryParameters) => {
			let queryParams: NarwhalQueryParameters = {
				...params,
				owner: this.authService.getCurrentUserId()
			};

			if (!Object.keys(queryParams).some(key => key === 'sortBy')) {
				queryParams = { ...queryParams, sortBy: defs.sortOrders.defaults.mySwarm };
			}

			this.narwhalService.setMySwarmQueryParams(queryParams);

			this.narwhalService.getNarwhals({ ...queryParams, p: 0, ps: this.bufferSize }).subscribe((chunk: NarwhalListResultDto) => {
				this.buffer = chunk.items;
				this.totalCount = chunk.total;
				this.maxProps = chunk.max;
				this.virtualScroll.scrollToIndex(0, true, 0, 0);
				this.virtualScroll.refresh();
			});
		});

		this.endOfList$
			.pipe(
				distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
				tap(event => this.log.debug('ChangeEvent', event)),
				filter(event => event.end === this.buffer.length - 1 && this.buffer.length < this.totalCount),
				untilComponentDestroyed(this)
			)
			.subscribe(this.fetchMore);
	}

	fetchMore = (event: ChangeEvent) => {
		this.loading = true;
		this.log.trace('=== fetchNextChunk ===');
		this.narwhalService
			.getNarwhals({
				...this.narwhalService.mySwarmQueryParams.getValue(),
				ownerId: this.authService.getCurrentUserId(),
				p: Math.ceil(this.buffer.length / this.bufferSize),
				ps: this.bufferSize
			})
			.subscribe((chunk: NarwhalListResultDto) => {
				this.buffer = this.buffer.concat(chunk.items);
				this.loading = false;
			}, () => (this.loading = false));
	};

	updateName($event) {
		const renamedNarwhal = this.scrollItems.find(element => element.id === $event.narwhalId);
		renamedNarwhal.name = $event.newName;
	}
}